// extracted by mini-css-extract-plugin
export var detailWrap = "testimonial-module--detailWrap--aea32";
export var firstNameTitle = "testimonial-module--firstNameTitle--e901d";
export var light = "testimonial-module--light--0fbe0";
export var location = "testimonial-module--location--6e7e5";
export var mediaWrap = "testimonial-module--mediaWrap--d6202";
export var odd = "testimonial-module--odd--544a3";
export var propertyType = "testimonial-module--propertyType--e38b1";
export var quoteWrap = "testimonial-module--quoteWrap--496b5";
export var testimonial = "testimonial-module--testimonial--8c142";
export var withImage = "testimonial-module--withImage--9edc9";
export var wrap = "testimonial-module--wrap--08a2e";